import logoSrc from '../assets/Logo-PropHero-Large.png';
import type { PropHeroBackgroundIconProps } from './PropHeroBackgroundIcon.types';

export function PropHeroBackgroundIcon({ className = '' }: PropHeroBackgroundIconProps) {
	return (
		<div
			className={`fixed inset-y-0 -right-20 w-1/2 z-0 pointer-events-none select-none opacity-20 ${className}`.trim()}
			aria-hidden="true"
		>
			<img
				src={logoSrc}
				alt=""
				className="h-full w-full object-contain block -rotate-12 scale-90"
				decoding="async"
				loading="eager"
			/>
		</div>
	);
}

export default PropHeroBackgroundIcon;
